import { createContext, useContext, useState } from 'react';

const AiChatPanelContext = createContext({
    isOpen: false,
    toggle: () => {},
    close: () => {},
    spawnPosition: null,
    setSpawnPosition: () => {},
});

function AiChatPanelContextProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const [spawnPosition, setSpawnPosition] = useState(null);

    const toggle = () => setIsOpen((previous) => !previous);
    const close = () => setIsOpen(false);

    return (
        <AiChatPanelContext.Provider value={{ isOpen, toggle, close, spawnPosition, setSpawnPosition }}>
            {children}
        </AiChatPanelContext.Provider>
    );
}

export default AiChatPanelContextProvider;

export const useAiChatPanelContext = () => useContext(AiChatPanelContext);
